import {Fancybox} from "@fancyapps/ui";

Fancybox.bind('[data-fancybox="gallery"]', {
    // Options will go here
});